import styled from "styled-components";
import { Colors } from "../../globalStyles";

export const Nav = styled.nav`
  display: flex;
  background-color:  ${Colors.primary};
  color: white;
  padding: 1rem;
`;
